import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type InterviewRenameFailedAction = {
	type: 'INTERVIEW_RENAME_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): InterviewRenameFailedAction => ({
	type: 'INTERVIEW_RENAME_FAILED',
	payload,
});
